/* global femcare */

femcare.askExpert.askExpertDetail = {
    init: function() {
        $('.ask-expert-article #article-upvote').on('click', function() {
            var $this = $(this);
            $this.toggleClass('has-voted');
        });

        $('.ask-expert-article #article-downvote').on('click', function() {
            var $this = $(this);
            $this.toggleClass('has-voted');
        });
    }
};
